import React, { useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Modal } from "antd"


import * as Template from "../../templates";
import * as actions from "../../actions";
import { useState } from "react";
import { formatNumber } from "../../libraries/helper";
import { useLocation } from "react-router-dom";

export default () => {
  const moduleName = "wholesale_requests";
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const location = useLocation( )
  const [lgShow, setLgShow] = useState(false);
  const [lgShowShipping, setLgShowShipping] = useState(false);
  const [products, setProducts] = useState([]);
  const [request, setRequest] = useState();
  const [lgUserShow, setLgUserShow] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [updateRequestId, setUpdateRequestId] = useState(false);
  const [state, setState] = useState(``);

  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleChangeState = (value) => setState(value);

  const changeModal = (status, invoiceId) => {
    setLgShow(status);
    if (invoiceId > 0) {
      dispatch(actions.edit(invoiceId, `wholesale_requests`));
    }
  };

  const changeModalShipping = (status, invoiceId) => {
    setLgShowShipping(status);
    if (invoiceId > 0) {
      dispatch(actions.edit(invoiceId, `wholesale_requests`));
    }
  };

  const changeUserModal = (status, invoiceId) => {
    setLgUserShow(status);
    setUpdateRequestId(invoiceId)
    if (invoiceId > 0) {
      dispatch(actions.edit(invoiceId, `wholesale_requests`));
    }
  };

  const handleClick = () => {
    dispatch(actions.update(updateRequestId, moduleName));
    setSubmitted(true)
  };

  useEffect(() => {

    if (appReducer.wholesale_requests_edit != undefined) {
      setProducts(appReducer.wholesale_requests_edit.data.wholesale_products)
    }

    if (submitted) {
      if (appReducer.wholesale_requests_update != undefined) {
        changeUserModal(false, 0)
        setSubmitted(false)
      }

    }

    if (appReducer.wholesale_requests_edit != undefined) {

      let currentRequest = appReducer.wholesale_requests_edit.data;

      setRequest(currentRequest)

      setState(currentRequest.state)

      let statueValue = "در انتظار"

      switch (currentRequest.state) {
        case "accepted":
          statueValue = "تایید شده"
          break;
        case "rejected":
          statueValue = "رد شده"
          break;
      }

      setState({
        value: currentRequest.state,
        label: statueValue,
      });
    }

  }, [appReducer]);


  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.wholesale_requests_destroy, location.search]);

  useEffect(() => {

    if (appReducer.wholesale_requests_list != undefined) {
      setRows(appReducer.wholesale_requests_list.data)
      setTotalPages(appReducer.wholesale_requests_list.count)
    }

  }, [appReducer.wholesale_requests_list])


  const columns = [
    {
      name: 'نوع',
      selector: row => row.type == "legal" ? "حقوقی" : "حقیقی",
    },
    {
      name: 'کد‌ پیگیری',
      selector: row => row.code,
    },
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'استان',
      selector: row => row.city.province.name,
    },
    {
      name: 'شهر',
      selector: row => row.city.name,
    },
    {
      name: 'نام نماینده',
      selector: row => row.agent,
    },
    {
      name: 'آدرس',
      selector: row => row.address,
    },
    {
      name: 'تلفن ثابت',
      selector: row => row.tell,
    },
    {
      name: 'تلفن همراه',
      selector: row => row.mobile,
    },
    {
      name: 'کد پستی',
      selector: row => row.zipcode,
    },
    {
      name: 'شناسه ملی',
      selector: row => row.identity,
    },
    {
      name: 'شماره ثبت',
      selector: row => row.certificate ?? "-",
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <div>
        <Template.Button
          onClick={() => changeModal(true, row.id)}
          label="مشاهده اقلام"
          background="bg-gradient-to-tr from-blue-300 to-blue-400 text-xs "
        />
        <Template.Button
          onClick={() => changeModalShipping(true, row.id)}
          label="اطلاعات ارسال"
          background="bg-gradient-to-tr from-amber-300 to-amber-400 text-xs"
        />
        <Template.Button
          onClick={() => changeUserModal(true, row.id)}
          label="بروزرسانی"
          background="bg-gradient-to-tr from-indigo-300 to-indigo-400 text-xs"
        />
      </div>,
    },
  ];

  const productColumns = [
    {
      name: 'محصول',
      selector: row => <img className="w-24" src={row.wholesale.product_price.url_full ? row.wholesale.product_price.url_full : row.wholesale.product_price.product.active_image} height={100} />,
    },
    {
      name: 'نام محصول',
      selector: row => <p>{row.wholesale.product_price.product.name} {row.wholesale.product_price.name} ({row.wholesale.name})</p>,
    },
    {
      name: 'قیمت واحد',
      selector: row => formatNumber(row.price),
    },
    {
      name: 'تعداد',
      selector: row => row.quantity,
    },
    {
      name: 'قیمت نهایی',
      selector: row => <div className="alert">
        <ul style={
          {
            listStyle: "none"
          }
        }>
          <li>قیمت: {formatNumber(row.price)} تومان</li>
          <li>تعداد:‌ {row.quantity}</li>
          <li>تخفیف:‌ {row.discount > 0 ? row.discount : "-"}</li>
          <li>نهایی‌: {formatNumber(row.payable)} تومان</li>
        </ul>
      </div>,
    }
  ];

  return (
    <div>

      <Modal
        title="مشاهده اقلام"
        open={lgShow}
        centered
        footer={[<div></div>]}
        onCancel={() => changeModal(false, 0)}
      >

        <Template.Table columns={productColumns} data={products} />

      </Modal>

      <Modal
        title="بروزرسانی"
        open={lgUserShow}
        centered
        footer={[<div></div>]}
        onCancel={() => changeUserModal(false, 0)}
      >

        <Template.Form>

          {!!request && <div style={{ marginBottom: "20px" }} className="total-weight">مجموع وزن بسته ارسالی <b>{request.total_weight} کیلوگرم</b> می‌باشد.</div>}
          <Template.Input value={request ? request.shipping_price : ""} required className="ltr" label="هزینه ارسال" name="shipping_price" type="text" />
          <Template.SingleSelect
            withLabel
            required
            placeholder="مرحله جدید"
            onChange={handleChangeState}
            name="state"
            value={state}
            options={[
              {
                value: "waiting",
                label: "در انتظار",
              },
              {
                value: "accepted",
                label: "تایید‌شده",
              },
              {
                value: "rejected",
                label: "لغوشده",
              }
            ]}
          />
          <Template.Textarea
            value={request ? request.content : ""}
            label="توضیحات تکمیلی"
            name="content"
            type="text"
          />
          <Template.Button
            label="ذخیره"

            onClick={handleClick}
          />
        </Template.Form>
      </Modal>

      <Modal
        title="اطلاعات ارسال"
        open={lgShowShipping}
        centered
        footer={[<div></div>]}
        onCancel={() => changeModalShipping(false, 0)}
      >

        {!!request && <div>
          <div className="font-bold text-sm my-5 text-blue-600">مجموع وزن بسته ارسالی <b>{request.total_weight} کیلوگرم</b> می‌باشد.</div>
          <ul className="flex flex-col space-y-5">
            <li>استان:‌ {request.city.province.name}</li>
            <li>شهر:‌ {request.city.name}</li>
            <li>کدپستی:‌ {request.zipcode}</li>
            <li>آدرس:‌ {request.address}</li>
          </ul></div>}
          
      </Modal>

      <Template.Table count={totalPages} columns={columns} data={rows} />

    </div>
  )

};
